<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Address Details</h4>
</div>
<div class="modal-body">
	<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="addressForm" #f="ngForm" autocomplete="off">
        <fieldset [hidden]="showValidationSelection">
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label class="required" title="* Required" for="addressTypeId">Address Type</label>
                    <select class="mvd_form-control" id="addressTypeId" formControlName="addressTypeId">
                        <option [ngValue]="null"></option>
                        <option [ngValue]="addressType.id" *ngFor="let addressType of addressTypes">{{addressType.displayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('addressTypeId', 'required')">Address Type is required</div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group" [hidden]="addressForm.get('addressTypeId').value == addressTypesData.Physical.id || addressForm.get('addressTypeId').value == addressTypesData.Domicile.id || !addressForm.get('addressTypeId').value">
                    <label for="inCareOf">In Care Of</label>
                    <input id="inCareOf" class="mvd_form-control" type="text" formControlName="inCareOf" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('inCareOf', 'maxlength')">In Care of has a maximum length of {{addressForm.get('inCareOf').errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group" [hidden]="addressForm.get('addressTypeId').value != addressTypesData.Mailing.id" *ngIf="countryData.US.id == addressForm.get('countryId').value">
                    <label for="isMilitary">Military Address</label>
                    <input type="checkbox" formControlName="isMilitary">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8 mvd_form-group">
                    <label class="required" title="* Required" for="addressLine1">Street Address</label>
                    <input id="addressLine1" class="mvd_form-control" type="text" formControlName="addressLine1" maxlength="40" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('addressLine1', 'maxlength')">Street Address has a maximum length of {{addressForm.get('addressLine1').errors.maxlength.requiredLength}} characters</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('addressLine1', 'required')">Street Address is required</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('addressLine1', 'poBoxDenied')">Not a valid {{addressTypeName}} address. Enter the physical location address.</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label for="addressLine2">Apt, Ste, Etc.</label>
                    <input id="addressLine2" class="mvd_form-control" type="text" formControlName="addressLine2" maxlength="40" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('addressLine2', 'maxlength')">Apt, Ste, Etc. has a maximum length of {{addressForm.get('addressLine2').errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-sm-5 mvd_form-group">
                    <label class="required" title="* Required" for="city">City</label>
                    <div [hidden]="addressForm.get('isMilitary').value">
                        <input id="city" class="mvd_form-control" type="text" formControlName="city" [hidden]="addressForm.get('isMilitary').value" />
                    </div>
                    <div [hidden]="!addressForm.get('isMilitary').value">
                        <select id="militaryCityPrefixTypeId" class="mvd_form-control" formControlName="militaryCityPrefixTypeId">
                            <option [ngValue]="null"></option>
                            <option [ngValue]="city.id" *ngFor="let city of militaryCities">{{city.displayValue}}</option>
                        </select>
                    </div>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('city', 'maxlength')">City has a maximum length of 26 characters</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('city', 'required')">City is required</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('militaryCityPrefixTypeId', 'required')">City is required</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('city', 'cityDenied')">City is not allowed</div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label for="jurisdictionId" class="required" title="* Required">State</label>
                    <ng-container *ngIf="isJurisdictionApplicable">
                        <div [hidden]="addressForm.get('isMilitary').value">
                            <select class="mvd_form-control" id="jurisdictionId" formControlName="jurisdictionId">
                                <option [ngValue]="null"></option>
                                <option [ngValue]="state.id" *ngFor="let state of filterStates()">{{state.displayValue}}</option>
                            </select>
                        </div>
                        <div [hidden]="!addressForm.get('isMilitary').value">
                            <select class="mvd_form-control" id="militaryJurisdictionId" formControlName="militaryJurisdictionId">
                                <option [ngValue]="null"></option>
                                <option [ngValue]="state.id" *ngFor="let state of militaryJurisdictions">{{state.displayValue}}</option>
                            </select>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!isJurisdictionApplicable">
                        <input class="mvd_form-control" type="text" id="jurisdictionId" formControlName="internationalJurisdiction">
                        <div class="mvd_alert__validation">
                            <div class="mvd_alert__rule" *ngIf="hasValidationError('internationalJurisdiction', 'maxlength')">International jurisdiction has a maximum length of {{addressForm.get('internationalJurisdiction').errors.maxlength.requiredLength}} characters</div>
                        </div>
                    </ng-container>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('jurisdictionId', 'required')">State is required</div>
                        <div class="mvd_alert__rule" *ngIf="!hasValidationError('jurisdictionId', 'required') && hasValidationError('jurisdictionId', 'mustBeAZ')">Domicile address must be in AZ</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('militaryJurisdictionId', 'required')">State is required</div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label class="required" title="* Required" for="postalZipCode">ZIP Code</label>
                    <div [hidden]="addressForm.get('isMilitary').value">
                        <p-inputMask mask="99999?-9999" formControlName="postalZipCode" *ngIf="countryData.US.id == addressForm.get('countryId').value"></p-inputMask>
                        <input class="mvd_form-control" formControlName="postalZipCode" type="text" name="postalZipCode" *ngIf="countryData.US.id != addressForm.get('countryId').value">
                    </div>

                    <div [hidden]="!addressForm.get('isMilitary').value">
                        <select class="mvd_form-control" id="MilitaryZipCode" formControlName="militaryZipCode">
                            <option [ngValue]="null"></option>
                            <option [ngValue]="zip.id" *ngFor="let zip of militaryZipCodes">{{zip.value}}</option>
                        </select>
                    </div>
                    <div class="mvd_alert__validation" *ngIf="addressForm.get('postalZipCode').dirty || addressForm.get('postalZipCode').touched || addressForm.get('militaryZipCode').dirty || addressForm.get('militaryZipCode').touched">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('postalZipCode', 'maxlength')">ZIP Code has a maximum length of {{addressForm.get('postalZipCode').errors.maxlength.requiredLength}} characters</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('postalZipCode', 'required')">ZIP Code is required</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('militaryZipCode', 'required')">ZIP Code is required</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label for="countryId">Country</label>
                    <select id="countryId" class="mvd_form-control" formControlName="countryId">
                        <option [ngValue]="null"></option>
                        <option [ngValue]="country.id" *ngFor="let country of countries">{{country.displayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('countryId', 'required')">Country is required</div>
                        <div class="mvd_alert__rule" *ngIf="!hasValidationError('countryId', 'required') && hasValidationError('countryId', 'mustBeUS')">
                            Domicile address must be in the {{countryData.US.displayValue}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group" [hidden]="addressForm.get('isMilitary').value || false == showCountyInput || countryData.US.id != addressForm.get('countryId').value">
                    <label class="required" title="* Required" for="countyId">County</label>
                    <select class="mvd_form-control" id="countyId" formControlName="countyId">
                        <option [ngValue]="null"></option>
                        <option [ngValue]="county.id" *ngFor="let county of counties">{{county.displayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('countyId', 'mustBeEmpty')">County is only allowed when State is AZ</div>
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('countyId', 'required')">County is required when State is AZ</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9 col-md-6 mvd_form-group" *ngIf="addressForm.get('addressTypeId').value == addressTypesData.Physical.id || addressForm.get('addressTypeId').value == addressTypesData.Mailing.id">
                    <label class="required" title="* Required" for="addressSourceTypeId">Address Source</label>
                    <select class="mvd_form-control" id="addressSourceTypeId" formControlName="addressSourceTypeId">
                        <option [ngValue]="addressSource.id" *ngFor="let addressSource of addressSources">{{addressSource.displayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="hasValidationError('addressSourceTypeId', 'required')">Address Source is required</div>
                    </div>
                </div>
                <div class="col-sm-9 col-md-4 mvd_form-group" *ngIf="addressForm.get('addressTypeId').value != addressTypesData.OneTimeMailing.id && countryData.US.id == addressForm.get('countryId').value">
                    <label for="addressSourceTypeId">Emission Area Type</label>
                    <div class="mvd_form-control">{{ getEmissionsAreaTypeDisplayValue(this.addressForm.get('emissionAreaTypeId').value) }}</div>
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group" *ngIf="addressNumberId > 0 && !!addressData?.updatedDate">
                    <label>Date Updated</label>
                    <div class="mvd_form-control">{{addressData.updatedDate | shortDate}}</div>
                </div>
            </div>

            <div class="row" *ngIf="isIRPEdit">
                <div class="col-sm-7 mvd_form-group">
                    <label>Established Place of Business</label>
                    <input id="isEstablishedPlaceOfBusiness" type="checkbox" formControlName="isEstablishedPlaceOfBusiness" />
                </div>
            </div>
        </fieldset>

        <fieldset [hidden]="!showValidationSelection">
            <div class="row">
                <div class="col-sm-7 mvd_form-group">
                    <label>Address Entered</label>
                    <div class="mvd_form-control">
                        <b class="mvd_alert--label" *ngIf="!matched">&nbsp;{{matchingMessage}} </b> {{displayAddress}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5 mvd_form-group" *ngIf="!matched">
                    <label>Address Options</label>
                    <ul class="list--bulletless--content">
                        <li>
                            <label class="mvd_label--inline">
                                <input type="radio" name="validationType" formControlName="validationType" [value]="validationTypes.useCurrent" /> Use the entered address
                            </label>
                        </li>
                        <li>
                            <label class="mvd_label--inline"><input type="radio" name="validationType" formControlName="validationType" [value]="validationTypes.tryAgain" /> Re-enter the address and try again</label>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="row" *ngIf="validationTypes.useCurrent == addressForm.get('validationType').value && addressForm.get('addressTypeId').value != addressTypesData.Mailing.id && addressForm.get('addressTypeId').value != addressTypesData.OneTimeMailing.id">
                <div class="col-sm-7 mvd_form-group">
                    <label>Emission Area Type</label>
                    <select class="mvd_form-control" id="emissionAreaTypeId" formControlName="emissionAreaTypeId">
                        <option [ngValue]="nonMatchLatLongEmissionTypeValue"> - Select - </option>
                        <option ngValue="1">Area A Non-Attainment</option>
                        <option ngValue="2">Area B Non-Attainment</option>
                        <option ngValue="3">Exempt</option>
                    </select>
                </div>
            </div>

            <ng-container *ngIf="matched">
                <div class="row">
                    <div class="col-sm-7 mvd_form-group">
                        <label>Corrected</label>
                        <div class="mvd_form-control">
                            {{displayValidatedAddress}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12  mvd_form-group">
                        <label class="required" title="* Required">Address Options</label>
                        <ul class="list--bulletless--content">
                            <li>
                                <label class="mvd_label--inline">
                                    <input type="radio" name="validationType" formControlName="validationType" [value]="validationTypes.useCorrected" checked="checked" /> Use the corrected address
                                </label>
                            </li>
                            <li>
                                <label class="mvd_label--inline">
                                    <input type="radio" name="validationType" formControlName="validationType" [value]="validationTypes.useCurrent" /> Use the entered address
                                </label>
                            </li>
                            <li>
                                <label class="mvd_label--inline">
                                    <input type="radio" name="validationType" formControlName="validationType"  [value]="validationTypes.tryAgain" /> Re-enter the address and try again
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
	<div class="btn--group">
		<button class="btn--default" type="button" [disabled]="busy" (click)="cancel()" *ngIf="!showValidationSelection">Cancel</button>
		<button class="btn--accent" type="button" [disabled]="busy" (click)="setUndeliverable()" *ngIf="componentTypeName != 'domicile' && !showValidationSelection && addressNumberId && (!!addressData?.entityId || !isWip || !showValidationSelection || canSetUndeliverable)">
            <ng-container *ngIf="!addressForm.get('isUndeliverable').value && addressForm.get('addressTypeId').value != addressTypesData.Mailing.id">Set Undeliverable</ng-container>
            <ng-container *ngIf="!addressForm.get('isUndeliverable').value && addressForm.get('addressTypeId').value == addressTypesData.Mailing.id">Remove</ng-container><ng-container *ngIf="addressForm.get('isUndeliverable').value">Set Deliverable</ng-container>
        </button>
		<button class="btn--primary" type="button" [disabled]="(validationTypes.useCurrent == addressForm.get('validationType').value) && (nonMatchLatLongEmissionTypeValue == addressForm.get('emissionAreaTypeId').value)" (click)="continue()" *ngIf="showValidationSelection">Continue</button>
        <button class="btn--primary" type="button" [disabled]="busy" (click)="openEmissionAreaTypeModal()" *ngIf="addressNumberId != 0 && addressForm.get('addressTypeId').value != addressTypesData.OneTimeMailing.id && countryData.US.id == addressForm.get('countryId').value">Change Emission Area Type</button>
		<mvm-spinner-btn [btnType]="'button'" [isDisabled]="!(emissionsAreaTypeIdChanged || (addressForm.valid && addressForm.dirty)) || busy" [isLoading]="busy" btnText="Save" (clicked)="save()"  *ngIf="!showValidationSelection"></mvm-spinner-btn>
	</div>
</div>
